import React, { Component } from 'react';
import { imageAddress, textVariableReplacer, translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import IconMap from './IconMap';
import { saveAs } from 'file-saver';
import HttpServices from '../../utils/Http.services';
import CustomLoader from '../../components/CustomLoader';
import FilePreview from './FilePreview';
import SingleFileToolbar from './SingleFileToolbar';

class FileSinglePage extends Component {

    state = {
        filesPic: ['png', 'jpg', 'jpeg', 'svg'],
    }

    componentDidMount() {

        this.init()


    }

    componentDidUpdate(prevProps, prevState) {

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {

            this.init()

        }

    }

    init = () => {

        // console.log("INIT")
        let link
        if (this.props.windowData.path?.length > this.props.baseUrl?.length) {


            link = this.props.windowData.path[this.props.baseUrl?.length + 1]


        }

        let body = { link: link }

        // console.log(body)

        this.setState({ isLoadingFile: true, notFound: null, permissionDenied: null, file: null })

        HttpServices.request('getFile', body, (fetchResult, fetchError, fetchStatus) => {

            // console.log("getFile", fetchResult, fetchError)

            // if (fetchResult.folder && this.props.setCurrentFrame) {
            //     this.props.setCurrentFrame(fetchResult.folder)
            // }

            this.setState({ isLoadingFile: false })


            if (fetchError) {

                if (fetchStatus == 401) {
                    this.setState({ permissionDenied: true })
                } else {
                    this.setState({ notFound: true })
                }

                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }



            this.setState({ file: fetchResult.info }, () => {
                if (this.props.setHeader) {

                    this.props.setHeader({
                        'toolbar': this.toolbarView,
                        headerIdentityComponent: this.headerIdentityComponent,
                        // 'navbarComponent': this.navbarComponent,
                        'showToolbar': true,
                        'showFrames': false,
                        // 'showSettings': this.props.isApplet,
                        // onChangeDirectory: this.onChangeDirectory,
                        // isPortal: !this.props.isApplet,
                        // title: !this.props.isApplet && '{{lang}}Drive',
                        // type: 'drive'
                    })

                }
            })


            // if (fetchResult.folder) {
            //     let newPath = []
            //     fetchResult.folder?.parents?.forEach((element) => {
            //         newPath.push({ name: element.name, _id: element._id, link: element.link })
            //     })

            //     newPath.push({ name: fetchResult.folder.name, _id: fetchResult.folder._id, link: fetchResult.folder.link })
            // }
            // if (this.props.setHeader) {

            // }



        })

    }



    headerIdentityComponent = () => {
        let file = this.state.file
        return (
            <div className="flexc w-100  ">

                {/* <div className="br-30 px-1 flexcc" style={{ background: '#ffffff80', height: 30, width: 30, border: '2px solid #fff' }}>
                    <img className="flexcc" width={"100%"} src={IconMap[file?.extension?.toLowerCase() ?? file?.type] ?? '/assets/icons/applets/drive/unknown.png'} alt="" draggable={false} style={{}} />
                </div> */}

                <div className='mld-2'>
                    <p className='font-size-14 text-bold ' style={{ color: this.props.colors?.textColor, wordBreak: 'break-word' }}>{file?.name}<span >{file?.extension && '.' + file?.extension}</span></p>
                    <p className='font-size-12 text-semibold' style={{ color: this.props.colors?.textColor, }}>{translate("Drive portal")}</p>
                </div>
            </div>

        )
    }

    toolbarView = () => {
        return (
            <SingleFileToolbar ref={el => { this.driveToolbar = el }}
                colors={this.props.colors}
                language={this.props.language}
                width={this.props.width}
                currentSort={this.state.currentSort}
                currentApplet={this.props.currentApplet}
                frame={this.state.frame}
                currentAppletName={this.props.currentAppletName}
                setStateProps={this.setStateProps}
                sortList={this.sortList}
                changeFrame={this.changeFrame}
                setCurrentApplet={this.setCurrentApplet}
                openTemplatesModal={this.openTemplatesModal}
                setData={this.setData}
                openNote={this.openNote}
                createDoc={this.createDoc}
                isApplet={this.props.isApplet}
                applet={this.props.applet}
                changePage={this.props.changeStagePage}
                functionsHandler={this.functionsHandler}
                driveSections={this.state.driveSections}
                downloadFile={this.downloadFile}
            />
        )
    }

    downloadFile = (extra, info) => {
        let fullData = this.state.file
        // let file = 'test.png'
        // console.log(fullData)
        let data = textVariableReplacer(fullData, fullData.address, '', 'downloaaaad')
        // if (Array.isArray(this.props.params)) {
        //     for (let i = 0; i < this.props.params.length; i++) {
        //         const param = this.props.params[i];
        //         data = this.textVariableReplacer(param?.info, data, param.fields, param.label)

        //     }
        // }
        saveAs(imageAddress(data))

    }

    render() {
        let currentItem = this.state.file ?? {}
        return (
            <div className='w-100 h-100 sc-3' style={{ overflow: 'auto', backgroundColor: '#f0f0f0', }}>

                {this.state.isLoadingFile && (
                    <div className="mt-4 flexcc">
                        <CustomLoader isLoading={true} />
                    </div>
                )}

                {(!this.state.isLoadingFile && this.state.file) && (
                    <div className='h-100 w-100 px-3 pt-3 pb-3'>
                        {/* <div className="flexce w-100 px-3 py-2" style={{}}>



                            <div className="flexc mrd-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.downloadFile(currentItem) }}
                                    title={translate('Download')}
                                    icon='/assets/icons/drive/dl-white.svg'
                                    textColor={'#fff'}
                                    bg={this.props.colors ? this.props.colors.background : '#6B00B6'}
                                />
                            </div>
                            <div className="flexc mld-2">
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.props.shareModal()}
                                    title={translate('Share')}
                                    icon='/assets/icons/drive/share-white.svg'
                                    textColor={'#fff'}
                                    bg={this.props.colors ? this.props.colors.background : '#6B00B6'}
                                />
                            </div>
                        </div> */}

                        <FilePreview data={currentItem} downloadFile={this.downloadFile} colors={this.props.colors} width={this.props.width} />
                    </div>
                )}


                {this.state.notFound && (
                    <div>
                        <p>{translate("File does not exists")}</p>
                    </div>
                )}

                {this.state.permissionDenied && (
                    <div>
                        <p>{translate("You do not have permission to access this file")}</p>
                    </div>
                )}

            </div>
        );
    }


}

export default FileSinglePage;